import { createContext, useState } from "react";

export const CSVContext = createContext();

export const CSVContextProvider = ({ children }) => {
    const defaultOptionList = [
        {
            id: '1',
            type: 'product',
            images: []
        }
    ];

    const [optionList, setOptionList] = useState(defaultOptionList);
    const [category, setCategory] = useState('');
    const [productType, setProductType] = useState('');
    const [createCSVPage, setCreateCSVPage] = useState('category');
    const [downloadUrl, setDownloadUrl] = useState('');

    const contextValue = {
        category,
        setCategory,
        createCSVPage,
        setCreateCSVPage,
        optionList,
        setOptionList,
        downloadUrl,
        setDownloadUrl,
        productType,
        setProductType,
    };

    return (
        <CSVContext.Provider value={ contextValue }>
            { children }
        </CSVContext.Provider>
    );
}
